var map = {
	"./cbn.jpeg": 94,
	"./firs.jpeg": 95,
	"./nass.jpeg": 96,
	"./nphcda.jpeg": 97,
	"./popo.jpeg": 98,
	"./tetfund.jpeg": 99,
	"./uni.jpeg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;